import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { createMarkup } from '../../utils/utils';
import Card from '../../components/Card/Card';
import { Modal, ModalBody } from 'reactstrap';

const propTypes = {
  id: string.isRequired,
  className: string,
  html: string,
  defaultMessage: string,
};

const OfferCardItem = ({ id, defaultMessage, className, html }) => {
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.offsetHeight;
      setShowButton(contentHeight > 245);
    }
  }, [html]);

  const handleClick = () => {
    setExpanded((isExpanded) => !isExpanded);
  };

  const toogleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <Card>
      <FormattedMessage id={id} defaultMessage={defaultMessage}>
        {(label) => (
          <>
            <div
              ref={contentRef}
              data-label={label}
              className={cn('offer-info', className, {
                'offer-info-expanded': expanded,
                'offer-info-collapsed': !expanded && showButton,
              })}
              dangerouslySetInnerHTML={createMarkup(html)}
            />
            {showButton && (
              <button
                type="button"
                onClick={handleClick}
                className="offer-info-toggle offer-info-toggle-desk"
                aria-expanded={expanded}
              >
                {expanded ? (
                  <FormattedMessage id="main.hide" defaultMessage="Hide" />
                ) : (
                  'Читать полностью'
                )}
              </button>
            )}
            <button onClick={toogleModal} className="offer-info-toggle offer-info-toggle-mob">
              Читать полностью
            </button>
            <Modal
              isOpen={showModal}
              modalClassName="offer-info-modal"
              backdrop={true}
              toggle={toogleModal}
            >
              <ModalBody>
                <button className="offer-info-modal-close" onClick={() => setShowModal(false)} />
                <p className="offer-info-modal-title">Описание</p>
                <div
                  data-label={label}
                  className="offer-info"
                  dangerouslySetInnerHTML={createMarkup(html)}
                />
              </ModalBody>
            </Modal>
          </>
        )}
      </FormattedMessage>
    </Card>
  );
};

OfferCardItem.propTypes = propTypes;
export default OfferCardItem;
